"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Pagination = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var classnames_1 = __importDefault(require("classnames"));
var icons_1 = __importDefault(require("../../../assets/icons"));
var Divider_1 = require("../../atoms/Divider/Divider");
var IconButton_1 = require("../../atoms/IconButton/IconButton");
var Typography_1 = require("../../atoms/Typography/Typography");
var Pagination_static_1 = require("./Pagination.static");
var Pagination_styles_1 = __importDefault(require("./Pagination.styles"));
/**
 * Pagination molecule
 *
 * {@link https://stories.data.bmw.cloud/?path=/docs/molecules-pagination--bound-story Docs}
 * {@link https://github.com/bmw-cdh/cdh-data-portal-theme/tree/main/components/molecules/Pagination Source}
 */
var Pagination = function (_a) {
    var isOnLastPage = _a.isOnLastPage, isOnFirstPage = _a.isOnFirstPage, goToPreviousPage = _a.goToPreviousPage, goToNextPage = _a.goToNextPage, goToLastPage = _a.goToLastPage, goToFirstPage = _a.goToFirstPage, pageInfo = _a.pageInfo, className = _a.className;
    var classes = (0, Pagination_styles_1.default)();
    return ((0, jsx_runtime_1.jsxs)("div", __assign({ className: (0, classnames_1.default)(classes.root, className) }, { children: [(0, jsx_runtime_1.jsx)(Typography_1.Typography, { children: pageInfo }), (0, jsx_runtime_1.jsx)(Divider_1.Divider, { vertical: true, margin: { top: 0, left: 8, bottom: 0, right: 4 }, className: classes.divider }), (0, jsx_runtime_1.jsx)(IconButton_1.IconButton, { tooltip: isOnFirstPage ? undefined : Pagination_static_1.localText.firstPage, isDisabled: isOnFirstPage, icon: icons_1.default.doubleChevronLeft, onClick: goToFirstPage }), (0, jsx_runtime_1.jsx)(IconButton_1.IconButton, { tooltip: isOnFirstPage ? undefined : Pagination_static_1.localText.previousPage, isDisabled: isOnFirstPage, icon: icons_1.default.chevronLeft, onClick: goToPreviousPage }), (0, jsx_runtime_1.jsx)(Divider_1.Divider, { vertical: true, margin: { top: 0, left: 4, bottom: 0, right: 4 }, className: classes.divider }), (0, jsx_runtime_1.jsx)(IconButton_1.IconButton, { tooltip: isOnLastPage ? undefined : Pagination_static_1.localText.nextPage, isDisabled: isOnLastPage, icon: icons_1.default.chevronRight, onClick: goToNextPage }), (0, jsx_runtime_1.jsx)(IconButton_1.IconButton, { tooltip: isOnLastPage ? undefined : Pagination_static_1.localText.lastPage, isDisabled: isOnLastPage, icon: icons_1.default.doubleChevronRight, onClick: goToLastPage })] })));
};
exports.Pagination = Pagination;
